module.exports = __webpack_public_path__ + "static/media/ck.6ab8f4f6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ck.svg
// module id = 2064
// module chunks = 0